export default function ThreeSteps({
  title,
  subtitle,
  steps,
  backcolor = "#D1DFEA33",
}) {
  return (
    <section className="py-14 px-6" style={{ backgroundColor: backcolor }}>
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-[#0b3c5d] text-xl sm:text-3xl font-bold uppercase">
            {title}
          </h2>

          <p className="mt-4 text-sm md:text-base text-[#10324F]">{subtitle}</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 sm:gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative rounded-xl min-h-45 sm:min-h-55 p-6 backdrop-blur-[15px] mb-4"
              style={{
                boxShadow: `
                  rgb(167 191 210 / 40%) -15px -15px 20px inset,
                  rgb(170 188 202 / 30%) -20px -20px 30px
                `,
              }}
            >
              <span className="absolute -top-10 left-5 text-[90px] font-bold text-[#10324F]/10 leading-none">
                {step.number}
              </span>

              <div className="relative z-10 mt-6">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-px bg-[#10324F]"></div>

                  <span className="text-xs text-[#10324F] tracking-widest uppercase">
                    {step.label}
                  </span>
                </div>

                <h2 className="card-section-heading">{step.title}</h2>

                <p className="selfie-service-list-item-text">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
